import React, { useState } from 'react';
import { Box, TextField, Button } from '@material-ui/core';
import { useSelector, useDispatch } from 'dva';
// eslint-disable-next-line no-unused-vars
import { TextFieldCom, RadioFieldCom, AntdTreeFieldCom } from '../FormType';
import DialogDataML from '@/components/DialogDataML/DialogDataML';

const updateStrategyList = [
  { label: '手动更新', value: '1' },
  { label: '每日更新（每日凌晨自动更新）', value: '2' },
  // { label: '实时', value: '3', disabled: true },
];
const updateStrategyImportList = [
  { label: '手动更新', value: '1', disabled: true },
  // { label: '实时', value: '3', disabled: true },
];
const statusList = [
  { label: '启用', value: '1' },
  { label: '停用', value: '2' },
  // { label: '实时', value: '3', disabled: true },
];
export default ({
  queryType,
  control,
  errors,
  setValue,
  setError,
  clearErrors,
  chooseLabel,
}) => {
  const dispatch = useDispatch();
  const { labelDirectoryList } = useSelector((state) => state.labelManage);
  const [labelValue, setLabelValue] = useState('');
  const [canVisibleChange, setCanVisibleChange] = useState(true);
  const [labelStatus, setLabelStatus] = useState({ open: false, data: null });
  const [labelError, setLabelError] = useState(false);

  const treeNodeAdd = (e, item) => {
    e.stopPropagation();
    e.preventDefault();
    setCanVisibleChange(false);
    setLabelStatus({ open: true, data: item });
  };

  //添加子标签content
  const groupEditContent = () => {
    return (
      <Box
        sx={{
          display: 'flex',
          gap: '0 2px',
          alignItems: 'center',
          height: '56px',
        }}
      >
        <span>
          <span style={{ color: 'red' }}>*</span>目录名称：
        </span>
        <TextField
          sx={{ width: '256px' }}
          id="standard-basic"
          label=""
          variant="standard"
          value={labelValue}
          onChange={(e) => {
            e.target.value && setLabelError(false);
            setLabelValue(e.target.value);
          }}
          placeholder="请输入目录名称"
          error={labelError}
          helperText={labelError ? '目录名称不能为空并且不超过20个字符' : ''}
        />
      </Box>
    );
  };

  const onCloseDialog = (e) => {
    e.stopPropagation();
    e.preventDefault();
    setCanVisibleChange(true);
    setLabelStatus({ open: false, data: null });
    setLabelValue('');
    setLabelError(false);
  };

  const onSaveLabelDialog = () => {
    if (!labelValue || labelValue.length > 20) {
      setCanVisibleChange(true);
      setLabelError(true);
      return;
    }
    const { id } = labelStatus.data || {};
    dispatch({
      type: 'labelManage/postInsertOrUpdate',
      payload: {
        values: {
          id: null,
          pid: id,
          name: labelValue,
        },
      },
      callback: () => {
        setCanVisibleChange(true);
        setLabelStatus({ open: false, data: null });
        setLabelValue('');
        window.message.toast({
          type: 'success',
          message: '保存成功',
        });
      },
    });
  };

  //新建标签自定义按钮
  const initButton = () => {
    const buttonNode = (
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'flex-end',
          gap: '0 16px',
          width: '100%',
          marginBottom: '24px',
          marginRight: '24px',
        }}
      >
        <Button
          sx={{
            width: '100px!important',
          }}
          variant="contained"
          onClick={onCloseDialog}
          color="secondary"
        >
          取消
        </Button>
        <Button
          sx={{ width: '100px!important' }}
          variant="contained"
          onClick={onSaveLabelDialog}
        >
          确定
        </Button>
      </Box>
    );
    return { buttonNode, isShow: true, height: 'auto' };
  };

  return (
    <Box display="flex" gap="0 48px">
      <Box flex="1" display="flex" flexDirection="column" gap="40px 0">
        <TextFieldCom
          autoFocus={true} //If true, the input element is focused during the first mount.
          initLabel={true} //自定义的label是否显示
          showLabel={false} //是否需要显示label
          placeholder="请输入标签名称且不超过20个字符"
          queryType={queryType} //detail不可编辑用于详情
          helperText="" //用于校验的提醒文字
          name="name"
          label="标签名称" //label
          control={control}
          errors={errors}
          setValue={setValue}
          isPositiveNumber={false} //true 只能输入正数，false可以输入负数
          isParseInt={false} //true 只能输入正整数，false可以输入小数
          rules={{
            required: true, //是否是必填项true 必填 false 非必填
            maxLength: 20,
          }}
        />
        <Box>
          <AntdTreeFieldCom
            treeData={labelDirectoryList}
            fieldNames={{ title: 'name', key: 'id' }}
            label="标签目录"
            placeholder="请选择标签目录"
            showLabel={true} //是否需要显示label
            name="pid"
            queryType={queryType}
            setValue={setValue}
            control={control}
            errors={errors}
            setError={setError}
            clearErrors={clearErrors}
            nameMessage="标签目录是必选项"
            treeNodeAdd={treeNodeAdd}
            canVisibleChange={canVisibleChange}
            rules={{
              required: true, //是否是必填项true 必填 false 非必填
            }}
          />
        </Box>
        <RadioFieldCom
          initLabel={true} //自定义的label是否显示
          label="更新方式" //label
          queryType={queryType} //detail不可编辑用于详情
          control={control}
          lWidth="auto"
          name="updateStrategy"
          typeList={
            chooseLabel === 'importlabel'
              ? updateStrategyImportList
              : updateStrategyList
          }
        />
        <RadioFieldCom
          initLabel={true} //自定义的label是否显示
          label="标签状态" //label
          queryType={queryType} //detail不可编辑用于详情
          control={control}
          lWidth="auto"
          name="status"
          typeList={statusList}
        />
      </Box>
      <Box flex="1">
        <TextFieldCom
          initLabel={false} //自定义的label是否显示
          showLabel={true} //是否需要显示label
          placeholder="最大长度不超过200个字符"
          queryType={queryType} //detail不可编辑用于详情
          helperText="" //用于校验的提醒文字
          name="remark"
          label="备注" //label
          control={control}
          errors={errors}
          setValue={setValue}
          isPositiveNumber={false} //true 只能输入正数，false可以输入负数
          isParseInt={false} //true 只能输入正整数，false可以输入小数
          rules={{
            required: false, //是否是必填项true 必填 false 非必填
            maxLength: 200,
          }}
          multiline
          rows={8}
          variant="outlined"
          className={
            queryType === 'detail'
              ? 'textField-area-wrap textField-area-line-wrap'
              : 'textField-area-wrap'
          }
        />
      </Box>
      <DialogDataML
        open={labelStatus.open}
        title={
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
          >
            <span
              style={{ fontSize: '18px', fontWeight: 600, color: '#212121' }}
            >
              添加子目录
            </span>
          </Box>
        }
        content={groupEditContent()}
        handleClose={onCloseDialog}
        button={initButton()}
      />
    </Box>
  );
};
